import { useReactiveVar } from "@apollo/client";
import { useRouterState } from "@tanstack/react-router";
import { useState } from "react";

import MenuTabs from "@/components/menu-tabs";
import useDevice from "@/hooks/use-device";
import useScrollEvents from "@/hooks/use-scroll-events";
import { navBarEnabled } from "@/store";

import IosAppButton from "./ios-app-button";
import MobileBanner from "./mobile-banner";

export default function MenuTabBar() {
  const [isVisible, setIsVisible] = useState(true);

  const asPath = useRouterState({ select: (s) => s.location.href });
  const { isIos } = useDevice();
  const isEnabled = useReactiveVar(navBarEnabled);
  useScrollEvents({
    onScrollDown: () => setIsVisible(false),
    onScrollUp: () => setIsVisible(true),
  });

  return (
    <div className="md:hidden">
      <div
        className="fixed inset-x-0 bottom-0 z-50 transition-transform data-[state=hidden]:translate-y-full data-[state=visible]:translate-y-0"
        data-state={isEnabled && isVisible ? "visible" : "hidden"}
      >
        {isIos && <IosAppButton />}
        <div className="flex h-17.5 items-center justify-center border-white/10 border-t bg-light-black px-20">
          <MenuTabs />
        </div>
      </div>
      {isEnabled && isVisible && (
        <MobileBanner isHomePage={asPath === "/"} isIos={isIos} />
      )}
    </div>
  );
}
